import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
// Models
import * as model from '../utils/routing/routes.model';
import { User, MultipleApiResponse } from '@mocca-technologies/model';
// Utils
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TracksService {

  user = JSON.parse(localStorage.getItem('user')) as User;

  constructor(
    private http: HttpClient,
  ) { }

  //#region --> HTML Petition methods to the backend

  /**
   * Get track network by id
   * @param id unique identifier of the track network
   * @returns the track network
   */
  getTrackNetwork(id: string, username: string, password: string): Observable<HttpResponse<MultipleApiResponse>> {
    !environment.production && console.log('[TracksService] GET', model.TRACK_NETWORK, { networkId: id });
    const httpParams = new HttpParams()
      .set('networkId', id)
      .set('username', username)
      .set('password', password);

    return this.http.get<MultipleApiResponse>(
      model.TRACK_NETWORK,
      {
        observe: 'response',
        withCredentials: true,
        params: httpParams,
      })
      .pipe(
        tap((res: HttpResponse<MultipleApiResponse>) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        }),
      );
  }

  /**
   * Get all track networks from the infrastructure operator
   * @returns the infrastructure operator
   */
  getAllTrackNetworks(username: string, password: string): Observable<HttpResponse<MultipleApiResponse>> {
    !environment.production && console.log('[TracksService] GET', model.ALL_TRACK_NETWORKS, { operatorId: this.user.organizationUuid });
    const httpParams = new HttpParams()
      .set('operatorId', this.user.organizationUuid)
      .set('username', username)
      .set('password', password);

    return this.http.get<MultipleApiResponse>(
      model.ALL_TRACK_NETWORKS,
      {
        observe: 'response',
        withCredentials: true,
        params: httpParams,
      })
      .pipe(
        tap((res: HttpResponse<MultipleApiResponse>) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        }),
      );
  }

  /**
   * Given a location and a radius (meters), it returns the list of track network segments that are within that radius.
   * @param latitude latitude of the center point
   * @param longitude longitude of the center point
   * @param radius in meters
   * @returns Observable<HttpResponse<MultipleApiResponse>> with responseObject as TrackNetworkSegment[]
   */
  getNearTrackNetworkSegments(latitude: number, longitude: number, radius: number, username: string, password: string): Observable<HttpResponse<MultipleApiResponse>> {
    !environment.production && console.log('[TracksService] GET', model.TRACK_NETWORK_SEGMENTS_NEAR_LOC, { lat: latitude, lon: longitude, radius });
    const httpParams = new HttpParams()
      .set('lat', latitude.toString())
      .set('lon', longitude.toString())
      .set('radius', radius.toString())
      .set('username', username)
      .set('password', password);

    return this.http.get<MultipleApiResponse>(
      model.TRACK_NETWORK_SEGMENTS_NEAR_LOC,
      {
        observe: 'response',
        withCredentials: true,
        params: httpParams,
      })
      .pipe(
        tap((res: HttpResponse<MultipleApiResponse>) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        }),
      );
  }

  /**
   * Given a location and a radius (meters), it returns the list of track networks that are within that radius.
   * @param latitude latitude of the center point
   * @param longitude longitude of the center point
   * @param radius in meters
   * @returns Observable<HttpResponse<MultipleApiResponse>> with responseObject as TrackNetwork[]
   */
  getNearNetworkTracks(latitude: number, longitude: number, radius: number, username: string, password: string): Observable<HttpResponse<MultipleApiResponse>> {
    !environment.production && console.log('[TracksService] GET', model.TRACK_NETWORK_NEAR_LOC, { lat: latitude, lon: longitude, radius });
    const httpParams = new HttpParams()
      .set('lat', latitude.toString())
      .set('lon', longitude.toString())
      .set('radius', radius.toString())
      .set('username', username)
      .set('password', password);

    return this.http.get<MultipleApiResponse>(
      model.TRACK_NETWORK_NEAR_LOC,
      {
        observe: 'response',
        withCredentials: true,
        params: httpParams,
      })
      .pipe(
        tap((res: HttpResponse<MultipleApiResponse>) => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        }),
      );
  }

  //#endregion --> HTML Petition methods to the backend

}
